<script setup>
import BackButton from '@/components/shared/buttons/BackButton.vue'
import WidthLimiter from '@/components/shared/page/WidthLimiter.vue'
import {usePage} from '@/composables/use-page.js'
import {toRefs, watchEffect} from 'vue'

//Emits and props
defineEmits([
  'back',
])
const props = defineProps({
  header: {
    type: String,
    default: '',
  },
  isFloating: {
    type: Boolean,
    default: false,
  },
  canGoBack: {
    type: Boolean,
    default: false,
  },
})

//Refs and composables
const {header} = toRefs(props)
const {setTitle} = usePage()

//Watch header and set as page title
watchEffect(() => setTitle(header.value))
</script>

<template>
  <div
    v-if="!!header || $slots.header"
    :class="{
      [$style.wrapper]: true,
      [$style.floating]: isFloating,
    }"
  >
    <WidthLimiter :class="$style.inner">
      <BackButton
        v-if="canGoBack"
        @click="$emit('back', $event)"
      />
      <div :class="$style.header">
        <slot name="header">
          <h1 :class="$style.heading">
            {{ header }}
          </h1>
        </slot>
      </div>
    </WidthLimiter>
  </div>
</template>

<style module lang="scss">
.wrapper {
  background: var(--bg-page-element);
  border-bottom: 1px solid var(--color-borders);
  height: var(--navbar-height);
  flex: 0 0 var(--navbar-height);
  @media (min-width: 1024px) {
    margin-top: 1rem;
    border-bottom: 0;
    width: calc(1024px - 2rem);
    margin: 2rem auto 0;
    border-top-left-radius: var(--border-radius-m);
    border-top-right-radius: var(--border-radius-m);
    border: 1px solid var(--color-borders);
    border-bottom: 0;
    &.floating {
      border-radius: var(--border-radius-m);
      border-bottom: 1px solid var(--color-borders);
    }
  }
}
.inner {
  height: 100%;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0 1rem;
}
.header {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.heading {
  font-size: var(--font-size-heading-xs);
  font-weight: var(--font-weight-bold);
  line-height: var(--line-height-headings);
  margin: 0;
  @media (min-width: 768px) {
    font-size: var(--font-size-heading-s);
  }
}
</style>
